import { SvgIcon } from '@mui/material';
import colors from '../../../scss/colors';

function CheckedIcon({ isChecked }) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 17 17" fill={colors.PAGE_BACKGROUND}>
      <rect x="1" y="1" width="15" height="15" rx="2" stroke={colors.LIGHT_GREY} />
      {isChecked && (
        <path
          d="M12.5 5.2998L7 11.6998L4.5 8.79071"
          stroke={colors.PRIMARY_BLUE}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </SvgIcon>
  );
}

export default CheckedIcon;
